import { render, staticRenderFns } from "./my_area.vue?vue&type=template&id=15812f5a&"
import script from "./my_area.vue?vue&type=script&lang=js&"
export * from "./my_area.vue?vue&type=script&lang=js&"
import style0 from "./my_area.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports